<template>
    <div>
      <el-tooltip v-if="tipShow" class="item" effect="dark" :content="placeholder" placement="top">
          <el-date-picker
              v-model="id"
              type="datetimerange"
              :readonly="readonly"
              :disabled="disabled"
              :value-format="valueFormat"
              :clearable="clearable"
              :format="format"
              :start-placeholder="$t('form.startDateText')"
              :end-placeholder="$t('form.endDateText')"
              :default-time="defaultTime"
              class="full-width"
              :size="size"
              :picker-options="pickerOptions"
          />
      </el-tooltip>
      <el-date-picker v-else
          v-model="id"
          type="datetimerange"
          :readonly="readonly"
          :disabled="disabled"
          :value-format="valueFormat"
          :clearable="clearable"
          :format="format"
          :start-placeholder="$t('form.startDateText')"
          :end-placeholder="$t('form.endDateText')"
          :default-time="defaultTime"
          class="full-width"
          :size="size"
          :picker-options="pickerOptions"
      />
    </div>
  </template>
  <script>
  export default {
    name: 'BjDateTimerangePicker',
    props: {
      value: {
          type: Array,
          default: () => {
            return [];
          },
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      tipShow: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      startTime: {
        type: [Object, String],
        default: () => {
          return null;
        },
      },
      size: {
        type: String,
        default: 'mini',
      },
      clearable: {
        type: Boolean,
        default: true,
      },
      valueFormat: {
        type: String,
        default: 'yyyy-MM-dd HH:mm:ss',
      },
      format: {
        type: String,
        default: 'dd/MM/yyyy HH:mm:ss',
      },
      placeholder: {
        type: String,
        default: '',
      },
      defaultTime: {
        type: Array,
        default: () => {
          return ['00:00:00', '23:59:59'];
        },
      },
      pickerOptions: {
        type: [Object, String],
        default: () => {
        },
      }
    },
    data() {
      return {
        id: null,
      };
    },
    computed: {
    },
    watch: {
      value: {
        handler(v) {
          this.id = v || null;
        },
        immediate: true,
      },
      id(v) {
        this.$emit('input', v);
        this.$emit('change', v);
      },
    },
    activated() {
      this.id = this.value;
    },
    mounted() {},
    methods: {
    },
  };
  </script>
